class OrderSheetValidator {
    /**
     * Constructs an instance of OrderSheetValidator.
     * @param {Object} model - The model object to be validated.
     * @param {Object} $injector - The injector service for dependency injection.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;

        /**
         * Services
         */
        this._translate = null;
        /**
         * Lazy-loads the translation service.
         * @returns {Object} The translation service.
         */
        this.$translate = function () {
            if (!this._translate) {
                this._translate = this.$injector.get('$translate');
            }
            return this._translate;
        }.bind(this);

        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.LOGIC.ORDER-SHEET';
        this._message = null;
        this._moreInfoTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.LOGIC.ORDER-SHEET-MORE-INFO';
        this._forced_check = true;
    }

    /**
     * Validates the order of sheets in the model.
     * @param {string} from - The source of the validation request.
     * @returns {Object} The validation result object.
     */
    validate(from) {
        let result = {};
        let error = false;
        let sheets = this.model.getSheets();

        let sheetOrderString = [];
        for (let key in sheets) {
            let sheet = sheets[key];
            let sheet_next = sheets[parseInt(key) + 1];

            if (sheet_next && sheet_next.getShortTitle() < sheet.getShortTitle()) {
                error = true;
            }

            sheetOrderString.push(sheet.getTitle() ? (sheet.getTitle() + '  ' + sheet.getShortTitle()) : (this.$translate().instant("PREFIX.QUESTION-PART") + ' ' + (sheet.getShortTitle())));
        }

        result = {
            'onSheetBlur':      false,
            'onlyBanner':       true,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            error,
            'status':           error ? 'DANGER' : 'SUCCESS', // WARNING | DANGER | SUCCESS
            'message':          this.getErrorMessage(),
            'more_info':        sheetOrderString ? this.$translate().instant(this._moreInfoTranslateString, {s: ('<br>' + sheetOrderString.join(', '))}) : '',
            'message_template': false,
            'callbacks':        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };

        return result;
    }

    /**
     * Gets the error message for the validation.
     * @returns {string} The error message.
     */
    getErrorMessage() {
        let questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate().instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Checks if the validation is forced.
     * @returns {boolean} True if the validation is forced, false otherwise.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Gets the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'OrderSheetValidator';
    }
}

export default OrderSheetValidator;